// extracted by mini-css-extract-plugin
export default {"root":"ResetPasswordPopup_root__bdFYX","header":"ResetPasswordPopup_header__bMAxS","submit":"ResetPasswordPopup_submit__-95SS"};